import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

// Attention case should be respected
export default function themeReducer(state = initialState.theme, action: any) {
  switch (action.type) {
    case types.SAVE_THEME_SUCCESS:
      return action.theme;
    default:
      return state;
  }
}
